module.exports = __webpack_public_path__ + "static/media/bell.7859dae8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/bell.svg
// module id = 1180
// module chunks = 0